import axios from 'axios';

/**
 * TYPE
 */
export type ApiErrorDataResult= {
  displayableMessage: boolean | null,
  errorCode: string | null,
  errorMessageArgs: string | null,
  exceptionClassName: string | null,
  filed: string | null,
  message: string | null,
  object: string | null,
}

export type ApiErrorData = {
  result: ApiErrorDataResult| ApiErrorDataResult[]; 
}

// 서버에서 받은 ErrorData로 부터 애러 Result 뽑아내기
export const getErrorResult = (errorData: ApiErrorData): ApiErrorDataResult=>{
  const ErrorResult = Array.isArray(errorData.result) ? errorData.result[0]: errorData.result;

  return ErrorResult;
};

// 애러 Result로 부터 애러 메시지 뽑아내기
export const getErrorMessage = (
  errorResult: ApiErrorDataResult, 
  ERROR_CODE_MAPED_MESSAGE: Record<string, string>, 
  { 
    DEFAULT_ERROR_MESSAGE = '', 
    localFirst = false, 
    usingServerMsg = true
  }: {
    DEFAULT_ERROR_MESSAGE?: string, 
    localFirst?: boolean, 
    usingServerMsg?: boolean
  } = {}
) : string => {
  let ERROR_MESSAGE: string;

  const {message: serverMessage, errorCode, displayableMessage} = errorResult;

  // 서버 메시지 사용
  if(usingServerMsg && serverMessage && displayableMessage){
    // 로컬 우선?
    if(localFirst && errorCode && ERROR_CODE_MAPED_MESSAGE[errorCode]){
      ERROR_MESSAGE = ERROR_CODE_MAPED_MESSAGE[errorCode];
    // 서버 우선
    }else{
      ERROR_MESSAGE = serverMessage; 
    }
  // 로컬 메시지 사용
  }else{
    if(errorCode && ERROR_CODE_MAPED_MESSAGE[errorCode]){
      ERROR_MESSAGE = ERROR_CODE_MAPED_MESSAGE[errorCode];
    }else{
      ERROR_MESSAGE = DEFAULT_ERROR_MESSAGE;
    }
  }

  return ERROR_MESSAGE;
};


/**
 * 사용예시
 */
async function testCallApi(){
  try{
    const result = await axios.get('/test/api');

  }catch(error){
    if (axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, {'error-code-1': '비로그인 계정입니다'}, {DEFAULT_ERROR_MESSAGE:'다음에 다시 이용해주세요', localFirst: true, usingServerMsg: true});
    }
  }
}

